export class BaseExpressionRegister {
  constructor() {
    this._methods_names = [];
    this._methods_by_name = /* @__PURE__ */ new Map();
  }
  register(expression, name) {
    this._methods_names.push(name);
    this._methods_by_name.set(name, expression);
  }
  getMethod(name) {
    return this._methods_by_name.get(name);
  }
  availableMethods() {
    return this._methods_names;
  }
}
